module.exports = __webpack_public_path__ + "static/cosycolourmain-5d087b96d5784f74922d0af57eb5f505.png";